import { cn } from '@/utils/cn';
import type { Incident } from '@/types/admin.types';
import { formatDateTime } from '@/utils/formatters';
import { AlertTriangle, CheckCircle, Eye, Search } from 'lucide-react';

interface IncidentTimelineProps {
  incident: Incident;
}

const statusIcon = (status: string) => {
  switch (status) {
    case 'investigating': return <Search className="h-4 w-4 text-warning-500" />;
    case 'identified': return <Eye className="h-4 w-4 text-primary-400" />;
    case 'monitoring': return <AlertTriangle className="h-4 w-4 text-warning-500" />;
    case 'resolved': return <CheckCircle className="h-4 w-4 text-success-500" />;
    default: return <AlertTriangle className="h-4 w-4 text-neutral-500" />;
  }
};

export function IncidentTimeline({ incident }: IncidentTimelineProps) {
  return (
    <div className="space-y-0">
      {(incident.updates || []).map((update, i) => (
        <div key={i} className="flex gap-3">
          <div className="flex flex-col items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-neutral-100 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700">
              {statusIcon(update.status)}
            </div>
            {i < (incident.updates?.length || 0) - 1 && <div className={cn('w-0.5 flex-1 min-h-[20px] bg-neutral-200 dark:bg-neutral-700')} />}
          </div>
          <div className="pb-4">
            <p className="text-sm text-neutral-900 dark:text-neutral-200">{update.message}</p>
            <p className="text-xs text-neutral-500">{formatDateTime(update.timestamp)} - {update.status}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
